<app-help-page mainVideo="performance-report"
               [tutorials]="['performance-reports', 'dashboard-reports', 'cycle-reports', 'chart-reports', 'quick-start']"
               [videos]="['performance-report', 'custom-dashboard-report', 'cycle-report', 'report-templates', 'transaction-id-report', 'path-explorer-report']"></app-help-page>
